// extracted by mini-css-extract-plugin
module.exports = {"iconOnImageWrapper":"IconOnImage-module--iconOnImageWrapper--ko8B8","big":"IconOnImage-module--big--1F9Bd"};